<template>
  <div class="mycitys">
    <van-popup v-model="show" position="bottom" :style="{ height: '38%' }" >
      <van-area
        title="省市区"
        ref="myvanarea"
        :value="citys"
        :area-list="areaList"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data'
export default {
  name: 'citys',
  data() {
    return {
      show: false,
      areaList: areaList,
      citys: ''
    }
  },
  created() {
    console.log(this.areaList)
  },
  methods:{
    setShow() {
      this.show = true
      this.$nextTick(() => {
        this.$refs.myvanarea.reset(this.citys)
      })
    },
    reset(value) {
      this.citys = value
    },
    confirm(e) {
      this.$emit('setCity', e)
      this.show = false
    }
  }
}
</script>

<style lang="less">
.mycitys{
  .van-picker__toolbar{
    height:70px;
    line-height:70px;
  }
  .van-picker__cancel{
    font-size:30px;
    line-height:70px;
  }
  .van-picker__confirm{
    font-size:30px;
    line-height:70px;
  }
  .van-picker__title{
    font-size:30px;
    line-height:70px;
  }
  .van-ellipsis{
    font-size:30px;
  }
}
</style>
